import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import moment from 'moment';

import { OrigamiResponse, ServiceBase } from './base/service.base';
import { TopicField } from '@app/origami-api/utils/topic-utils';
import { ErrorCode } from '@app/origami-api/constants/error-codes';

export namespace BulkUploadService {
  export interface BulkDocumentUploadOptions {
    siteId: number;
    file: File;
    batchId?: number;
    unpackArchives: boolean;
    convertToPdf: boolean;
    tmfApplicable?: boolean;
    fullPath: string;
  }

  export interface BulkUploadServiceResult {
    BatchId: number;
    ErrorRecords: any[];
    FileNames: string[];
    id?: number; // for UI needs
  }

  export interface ProcessUploadedFileProcessingOptions {
    MetaData?: TopicField[];
    UnpackArchive: boolean;
    ConvertToPDF: boolean;
    TmfApplicable?: boolean;
    BatchId?: number;
    ReadyForWorkflow?: boolean;
    IsEffectiveDocument?: boolean;
    RelativeFilePath: string;
  }

  export interface ProcessUploadedFileOptions {
    siteId: number;
    fileToken: string;
    processingOptions: ProcessUploadedFileProcessingOptions;
  }

  export interface ProcessUploadedFileResult {
    BatchId?: number;
    ErrorCode?: ErrorCode;
    ErrorRecords?: any[];
    FileNames?: string[];
    JobId?: string;
  }
}

@Injectable()
// eslint-disable-next-line no-redeclare
export class BulkUploadService extends ServiceBase {
  serviceUrl = 'BulkUploadService.svc';

  bulkDocumentUpload(
    body: BulkUploadService.BulkDocumentUploadOptions,
  ): Observable<OrigamiResponse<BulkUploadService.BulkUploadServiceResult>> {
    const formData: FormData = new FormData();
    const batchId = body.batchId ? body.batchId.toString() : null;
    const options = {
      headers: {
        'Current-Date': moment(new Date()).format('MM/DD/YYYY'),
      },
    };

    formData.append('files', body.file, body.file.name);
    formData.append('siteId', body.siteId.toString());
    formData.append('FILEPATH_0', body.fullPath || body.file.name);
    formData.append('BATCHID', batchId || null);
    formData.append('DoNotChangeStatusCode', '1'); // hardcoded
    formData.append('unpackArchives', body.unpackArchives ? '1' : '0');
    formData.append('convertToPdf', body.convertToPdf ? '1' : '0');

    if (body.tmfApplicable !== undefined) {
      formData.append('TMFAPPLICABLE', body.tmfApplicable ? '1' : '0');
    }

    return this.origamiPost('/BulkDocumentUpload', formData, options, null, true);
  }

  processUploadedFile(
    params: BulkUploadService.ProcessUploadedFileOptions,
    silentErrors?: ErrorCode[],
  ): Observable<OrigamiResponse<BulkUploadService.ProcessUploadedFileResult>> {
    return this.origamiPost('/ProcessUploadedFile', params, null, silentErrors, true);
  }
}
